export enum SessionCallStatus {
  New = 0,
  Confirmed = 1,
  Canceled = 2,
  Modified = 3,
  NeedToCall = 4,
  Failed = 5
}

export enum SessionStatus {
  Pending = 0,
  InProgress = 1,
  Done = 2,
  Failed = 3,
  Canceled = 4
}

export enum SessionState {
  Pending = 0,
  InProgress = 1,
  Done = 2,
  Canceled = 3,
  Failed = 4
}

export interface BaseEntity {
  id: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface SessionCallEntity extends BaseEntity {
  state: SessionState;
  status: SessionCallStatus;
  dos: string;
  drName: string;
  patientName: string;
  patientLastName: string;
  patientPhone: string;
  patientAddress: string;
  destination: string;
  destinationInfo: string;
  appointmentTime: string;
  estimatedDuration?: string;
  extraNotes?: string;
  conversations?: string;
  summary?: string;
  sessionId: number;
  sessionEntity?: SessionEntity;
}

export interface SessionEntity extends BaseEntity {
  status: SessionStatus;
  scheduleTime: string;
  operatorPerCall: number;
  calls?: SessionCallEntity[];
}

export interface PaginatedResponse<T> {
  data: T[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
}